module.exports = __webpack_public_path__ + "img/fi-rr-time-forward.db8aeb74.svg";